export enum GameState {
  NOT_STARTED = 'NOT_STARTED',
  IN_GAME = 'IN_GAME',
  WON = 'WON',
  LOST = 'LOST'
}
